import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import CustomAlert from "../../components/CustomAlert";
import CustomLoading from "../../components/CustomLoading";
import { paths } from "../../config/router.config";
import { lab4services } from "../../services/wsclients/lab4services";
import { getCurrency, setPaymentLinkInfo } from "../../utils/commons";
import ProcessFormView from "../register/ProcessFormView";
import PaymentLinkView from "./PaymentLinkView";

export default function PaymentLinkController(props) {
    const history = useHistory();
    const { t } = useTranslation();
    const [showLoading, onShowLoading] = useState(false);
    const [showMainLoading, onShowMainLoading] = useState(false);
    const [paymentInfo, setPaymentInfo] = useState({});
    const [message, setMessage] = useState({});
    const [htmlContent, setHtmlContent] = useState(null);
    const [openProcessForm, setOpenProcessForm] = useState(false);
    const [confirm, setConfirm] = useState({});

    useEffect(() => {
        var url = new URL(window.location.href);
        let contact_code = null;
        if(url.pathname && url.pathname.includes("/vumatel/sms/paymentlink/")){
            let strPathName = url.pathname.split("/vumatel/sms/paymentlink/");
            if(strPathName && strPathName.length > 0 && strPathName[1]){
                contact_code = strPathName[1];
               onLoadPaymentInfo(contact_code);
            }
        }
    }, []);

    const onLoadPaymentInfo = async (contact_code) => {
        onShowLoading(true)
        try {
            let result = await lab4services.getPaymentInfoV2(contact_code);
            console.log("AAAA getPaymentInfoV2 result: ", result);
            if(result.code == 'OK'){
                if(result.data && result.data.crm_order_id) setPaymentInfo(result.data);                
            }
        } catch (ex) {
            console.log("AAAA onLoadPaymentInfo exception: ", ex);
        }
        onShowLoading(false);
    }

    const onLogin = () => {
        history.push(paths.login);
    }

    const onCancelOrder = async () => {
        try {
            // debugger;
            let result = await lab4services.cancelOrderV2(paymentInfo);
            console.log("AAAA cancelOrder result: ", result);
            if(result.code == 'OK'){
                showMessage(true, t('CANCEL_ORDER_SUCCESS'), () => {
                    history.push(paths.landing_page);
                });
            } else {
                showMessage(true, t('CANCEL_ORDER_FAILED'));
                return false;
            }
        } catch (ex) {
            console.log("AAAA onCancelOrder exception: ", ex)
        }
    }
 
    const showMessage = async (status, message, onClose) => {
        onShowLoading(false);
        setMessage({
            show: status,
            content: message ? message : null,
            action: onClose,
        });
    }

    const onContinuePayment = async () => {        
        onShowMainLoading(true);
        try {
            let isAllowLocation = await onCheckLocation(paymentInfo.location_reference);
            if (!isAllowLocation) return false;
            let body = {
                contact_id: paymentInfo.contact_id ? paymentInfo.contact_id : null,
                email_address: paymentInfo.email_address ? paymentInfo.email_address : null,
                contact_code: paymentInfo.contact_code ? paymentInfo.contact_code : null,
                amount: paymentInfo.order_amount ? paymentInfo.order_amount : null,
            };
            // debugger;
            let result = await lab4services.initPayment(body);
            console.log("AAAA initPayment result: ", result);
            if (result.code == 'OK') {
                let urlFormPaygate = document._portalConfig.urlFormPaygate;
                if (result && result.code === 'OK' && result.data && result.data.client_token) {
                    let clientToken = result.data.client_token;
                    var splitToken = clientToken.split("_zjjjvjgqhmnyzgqy_");
                    console.log('splitToken:', splitToken);
                    if (splitToken.length > 0) {
                        var payRequestIDRes = splitToken[0];
                        var checkSumRes = splitToken[1];
                        var htmlContent = '<form name="paymentForm" action="' + urlFormPaygate + '" method="POST">'
                            + '<input type="hidden" name="PAY_REQUEST_ID" value="' + payRequestIDRes + '">'
                            + '<input type="hidden" name="CHECKSUM" value="' + checkSumRes + '">'
                            + '</form>'
                        console.log('htmlContent:', htmlContent);
                        setPaymentLinkInfo(paymentInfo);
                        setHtmlContent(htmlContent);
                        setOpenProcessForm(true);
                    }
                } else if (result.data && result.data.state === 'REJECTED') {
                    showMessage({
                        show: true,
                        message: t('INIT_PAYMENT_REJECTED'),
                        isConfirm: true,
                        confirmAction: {
                            okTitle: t('btn_try'),
                            okAction: async () => {
                                await onContinuePayment()
                            },
                            cancelTitle: t('btn_close'),
                            cancelAction: () => {
                                setMessage({})
                            }
                        }
                    });
                }
            }
        } catch (ex) {
            console.log("AAAA onContinuePayment exception: ", ex);
        }
        onShowMainLoading(false);
    }

    const onCheckLocation = async (location_id) => {
        let isAllowLocation = false;
        try {
            let result = await lab4services.checkLocationAvaibleOrder(location_id);
            console.log("AAAA onCheckLocation result: ", result);
            if (result.code == 'OK') {
                if (result.data && result.data.is_available_create_order) {
                    isAllowLocation = true;
                } else {
                    showMessage(true, t('address_used'));
                    // setMessage({
                    //     show: true,
                    //     content: result.data && result.data.descriptions ? result.data.descriptions : t('address_used')
                    // });
                    isAllowLocation = false;
                }
            }
        } catch (ex) {
            console.log("AAAA onCheckLocation exception: ", ex);
        }
        return isAllowLocation;
    }

    return (
        <>
            <PaymentLinkView
                paymentInfo={paymentInfo}
                message={message}
                showLoading={showLoading}
                currency={getCurrency()}
                onLogin={onLogin}
                onCancelOrder={onCancelOrder}
                onContinuePayment={onContinuePayment}
            />
            {openProcessForm && <ProcessFormView
                open={openProcessForm}
                onClose={() => setOpenProcessForm(false)}
                html_content={htmlContent}
            />}
            {message && message.show && <CustomAlert
                open={message.show}
                message={message.content}
                showButtonClose={true}
                isConfirm={message.isConfirm ? message.isConfirm : null}
                confirmAction={message.confirmAction ? message.confirmAction : null}
                onClose={message.action ? message.action : () => setMessage({})}
            />}
            {showMainLoading && <CustomLoading open={showMainLoading} />}
        </>
    )
}